import api from './api';

export default class AvaliacoesEstagioProbatorioService {
  static id = null;

  constructor() {
    throw 'Não é possível instanciar AvaliacoesEstagioProbatorioService';
  }

  static async lista(id) {
    const endpoint = mergeEndpoint(id);
    return await api.get(endpoint);
  }
}

const mergeEndpoint = id => {
  return `avaliacoes-estagio-probatorio/avaliados/${id}/avaliacoes-estagio-probatorio/competencias`;
};



// WEBPACK FOOTER //
// ./src/services/avaliacoesEstagioProbatorioService.js